// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W26Dcskt06IWbmAwA12s{padding:3px 22px 3px 3px;position:relative}.W26Dcskt06IWbmAwA12s .FjFjS6s80M0BkraPS2WR{margin:22px 0 18px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `W26Dcskt06IWbmAwA12s`,
	"tabs": `FjFjS6s80M0BkraPS2WR`
};
export default ___CSS_LOADER_EXPORT___;
